import React, { useRef } from "react"
import { ANSWER_LABELS } from "../../constants/answerLabels"


const PlusSign = () => (
    <svg width="24" height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 5V19M5 12H19"
            stroke="currentColor"
            strokeWidth="2" 
        />
        <path d="M12 9V15M9 12H15"
            stroke="currentColor"
            strokeWidth="2" 
        />
    </svg>
)

const ZeroSign = () => (
    <svg width="24" height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="12" cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2" 
        />
    </svg>
)

const MinusSign = () => (
    <svg width="24" height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="3" y="11"
            width="18"
            height="2"
            fill="currentColor" 
        />
    </svg>
)

const TextNo = () => (
    <div className="text">
        <p>Auf<br/>keinen<br/>Fall</p>
	</div>
)


const TextYes = () => (
    <div className="text">
        <p>Passt<br/>total</p>
	</div>
)

const Symbol = ({ val }) => (
    4 === val ? <><PlusSign /><PlusSign /></>
    : 3 === val ? <PlusSign />
    : 2 === val ? <ZeroSign />
    : 1 === val ? <MinusSign />
    : <><MinusSign /><MinusSign /></>
)

// Native Radios, visuell versteckt: Pfeiltasten, Leertaste und Fokusreihenfolge
// sind damit Browserverhalten, keine eigene Tastaturlogik. Das Symbol steht im
// label, der Name im jm-sr-only-Text (#178).
// aktiv=false: die Folie ist von react-slick per aria-hidden versteckt — ihre
// Radios stehen dann ausserhalb der Tab-Reihenfolge (axe: aria-hidden-focus).
//
// Markieren und Antworten sind zweierlei (Spec 4.2.1): der Pfeil markiert eine
// Stufe (onWaehle), Klick und Leertaste beantworten die Frage (onAnswer), und
// erst die Antwort blaettert weiter. Der Browser feuert beim Pfeil click und
// change auf der neuen Stufe, bei der Leertaste auf einer schon markierten
// Stufe gar nichts (Chromium, nachgemessen) — darum merkt sich die Reihe die
// gedrueckte Taste.
const Stufe = ({ questionId, val, value, aktiv, tasten }) => {
    const id = `${questionId}-stufe-${val}`

    return (
        <label htmlFor={id} className={"jm-answer" + (value === val ? ' selected' : '')}>
            <input
                id={id}
                className="jm-sr-only"
                type="radio"
                name={questionId}
                value={val}
                checked={value === val}
                tabIndex={aktiv ? undefined : -1}
                onKeyDown={tasten.gedrueckt}
                onKeyUp={event => tasten.losgelassen(event, val)}
                onClick={() => tasten.geklickt(val)}
                onChange={() => tasten.markiert(val)}
            />
            <Symbol val={val} />
            <span className="jm-sr-only">{ANSWER_LABELS[val]}</span>
        </label>
    )
}

const PFEILE = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']

const useTasten = (onWaehle, onAnswer) => {
    const perPfeil = useRef(false)
    const bestaetigt = useRef(false)

    return {
        gedrueckt: event => {
            perPfeil.current = PFEILE.includes(event.key)
            bestaetigt.current = ' ' === event.key && event.currentTarget.checked
        },
        losgelassen: (event, val) => {
            if (' ' === event.key && bestaetigt.current) {
                onAnswer(val)
            }
        },
        // Der Klick nach einem Pfeil stammt vom Pfeil; jeder weitere ist wieder
        // Maus, Finger oder Leertaste.
        geklickt: val => {
            const vomPfeil = perPfeil.current
            perPfeil.current = false
            if (!vomPfeil) {
                onAnswer(val)
            }
        },
        markiert: val => onWaehle(val)
    }
}

const QuestionsAnswers = ({
    questionId,
    question,
    value,
    onAnswer,
    onWaehle = () => {},
    aktiv = true
}) => {
    const tasten = useTasten(onWaehle, onAnswer)

    return (
        <fieldset className="jm-answers" role="radiogroup" aria-label={question}>
            <TextNo />

            <div className="d-flex">
                {[0, 1, 2, 3, 4].map(val => (
                    <Stufe key={val} questionId={questionId} val={val} value={value} aktiv={aktiv} tasten={tasten} />
                ))}
            </div>

            <TextYes />
        </fieldset>
    )
}

export default QuestionsAnswers
